import { AxCustomer } from './AxCustomer';

export interface IAxCostumers {
    /**
     * Date of latest changes on api side
     */
    date: string;
    /**
     * List of customers
     */
    customers?: AxCustomer[];
}

export class AxCostumers implements IAxCostumers {
    public date: string;
    public customers?: AxCustomer[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IAxCostumers);
    constructor(obj?: any) {
        this.date = obj && obj.date != null && obj.date.length > 0 ? obj.date : undefined;

        if (obj && obj.customers !== undefined) {
            this.customers = [];
            obj.customers.forEach((customer: AxCustomer) => {
                if (this.customers) {
                    this.customers.push(new AxCustomer(customer));
                }
            });
        } else if (obj && obj.axCustomers !== undefined) {
            this.customers = [];
            obj.axCustomers.forEach((customer: AxCustomer) => {
                if (this.customers) {
                    this.customers.push(new AxCustomer(customer));
                }
            });
        }
    }
}
